<template>
    <div class="shareGuide" @touchmove.prevent @mousewheel.prevent>
        <!-- 关注 -->
        <div class="fixed_btn attention" @click="showAttention"><span><van-icon name="like-o" />关注</span></div>
        <!-- 分享弹窗 -->
        <div class="attent-shade attentionFlag" @touchmove.prevent>
            <div class="attention">
                <p class="title">长按扫码关注星妈会<br/>开启快乐育儿&nbsp;&nbsp;领取积分好礼</p>
                <div class="attent-img"><img src="../../assets/images/baby/2wei.png"/></div>
                <div class="attent-class">
                    <div class="attent-item">
                        <div><img src="../../assets/images/icon/icon1.png"/></div>
                        <p>专家问答<br/> 为您解决育儿烦恼</p>
                    </div>
                    <div class="attent-item">
                        <div><img src="../../assets/images/icon/icon2.png"/></div>
                        <p>星妈优选<br/> 精选育儿佳品</p>
                    </div>
                    <div class="attent-item">
                        <div><img src="../../assets/images/icon/Icon3.png"/></div>
                        <p>育儿提醒<br/> 您专属的育儿工具</p>
                    </div>
                    <div class="attent-item">
                        <div><img src="../../assets/images/icon/icon4.png"/></div>
                        <p>精品课程<br/> 百余名知名育儿专家</p>
                    </div>
                </div>
                <div class="btn" @click="closeAttention"><van-icon name="close" /></div>
            </div>
        </div>
    </div>
</template>
<style lang="less" scoped>
.shareGuide{
    // 关注、分享
    .fixed_btn{
        width:44px;
        height:44px;
        box-shadow:0px 4px 10px 0px rgba(0,0,0,0.24);
        position: fixed;
        right: 12px;
        background: @expertFontColor255;
        border-radius:22px;
        text-align: center;
        z-index: 9;
        span{
            .van-icon{
                font-size:@indexFontSize14;
                display: block;
                margin-top: 7px;
            }
        }
    }
    .attention{
        bottom: 120px;
    }
    //分享遮罩
    .attent-shade{
        position: fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background:rgba(0,0,0,0.6);
        display: none;
        z-index: 9999999;
        // 分享弹窗
        .share_desc{
            font-size:18px;
            font-weight:bold;
            color:@expertFontColor255;
            line-height:28px;
            margin-top: 26px;
            margin-left: 27px;
            p{
                width: 256px;
                img{
                    width:18px;
                    height:18px;
                }
            }
            .share-line{
                text-align: right;
                width: 306px;
                height: 75px;
                img{
                    width: 135px;
                    height: 75px;
                    display: block;
                    float: right;
                }
            }
            .btn_close{
                width:23px;
                height:23px;
                position: fixed;
                bottom: 106px;
                left:175px;
                .van-icon{
                    font-size: @indexFontSize22;
                }
            }
        }

        // 关注弹窗
        .attention{
            color: @expertFontColor255;
            .title{
                margin: 58px auto 10px;
                font-size:18px;
                font-weight:bold;
                color:@expertFontColor255;
                line-height:28px;
                text-align: center;
            }
            .attent-img{
                text-align: center;
                margin-bottom: 16px;
                img{
                width: 168px;
                height: 228px;
                }

            }
            .attent-class{
                padding-left: 37px;
                display: flex;
                flex-wrap: wrap;
               .attent-item{
                   display: flex;
                   margin-right: 27px;
                   margin-bottom: 30px;
                   img{
                        width:22px;
                        height:23px;
                        margin-right: 5px;
                        margin-top: 5px;
                   }
                   p{
                       width:112px;
                        font-size:12px;
                        font-weight:bold;
                        line-height:18px;
                   }
               }

            }
            .btn{
                width: 23px;
                height: 23px;
                position: fixed;
                left:174px;
                .van-icon{
                    font-size: @indexFontSize22;
                }
            }
        }

    }
}
</style>
<script>
export default {
    name:"shareGuide",
    props:['videoDetail'],
    data() {
        return {
            attentionFlag:false
        }
    },
    mounted(){
    },
    methods:{
        showAttention:function(){
            // 判断是为了分享的时候视频会在最高层遮住视频引导文案，只有在视频实例存在的时候再执行此方法
            if($('video').length > 0){
                this.$parent.$refs.HFVideo.Player.pause();
                $('#HF').css("background-image","url("+this.videoDetail.videoImg+")");
                $('video').css('display','none');
                $('.xgplayer-controls').css('opacity','0');
            }
            $(".attentionFlag").fadeIn(200);
        },
        closeAttention:function(){
            // 判断是为了分享的时候视频会在最高层遮住视频引导文案，只有在视频实例存在的时候再执行此方法
            if($('video').length > 0){
                // this.$parent.$refs.HFVideo.Player.play();
                $('#HF').css("background-image","");
                $('video').css('display','block');
                $('.xgplayer-controls').css('opacity','1');
            }
            $(".attentionFlag").fadeOut(200);
        }
    }
}
</script>
